import React from 'react';
import { Tooltip } from 'react-tooltip';
import Utilities from '@util/Utilities';
import HotelRoomWithMapping from '@app/model/company_hotel_room_mappings_type_configuration/HotelRoomWithMapping';


const HotelRoomMappingTooltip: React.FunctionComponent<{
	id: string,
	roomMapping: HotelRoomWithMapping,
	openOnClick?: boolean
}> = ({ id, roomMapping, openOnClick = true }) => {
	return <Tooltip id={id}
									openOnClick={openOnClick}
									opacity={100}
									className="z-40 bg-white w-[100px] shadow-2xl  text-xs"
									style={{ backgroundColor: 'white' }}>
		<div className="p-2">
			<h6 className="text-sm text-gray-900 font-bold border-b border-gray-200 mb-3 pb-1">{roomMapping.roomName}</h6>
			<div className="grid grid-cols-2 gap-x-3 gap-y-1 text-gray-800 text-xs">
				<div className="font-bold">Mapping:</div>
				<div className="font-normal">{Utilities.snakeCaseToWords(roomMapping.roomMappingName)}</div>
				<div className="font-bold">Size:</div>
				<div className="font-normal">{!!roomMapping.sqm ? roomMapping.sqm + ' sqm' : '-'}</div>
				<div className="font-bold">Max Persons:</div>
				<div
					className="font-normal">{roomMapping.maxPersons ? roomMapping.maxPersons + ' persons' : '-'}</div>
				<div className="font-bold">Ranking:</div>
				<div className="font-normal">{roomMapping.rankIndex}</div>
				<div className="font-bold">Median Price:</div>
				<div className="font-normal">&euro; {roomMapping.medianPrice}</div>
				<div className="font-bold">View:</div>
				<div className="font-normal">{roomMapping.view ?? '-'}</div>
			</div>
		</div>
	</Tooltip>;
};

export default HotelRoomMappingTooltip;